module.exports = __webpack_public_path__ + "static/media/noHandLady.14e5a7b5.png";